import { Component } from '@angular/core';
import { Location } from '@angular/common';

@Component({
  selector: 'erro-403',
  template: `
  <div class="ui-g">
    <div class="ui-g-12">
      <p>
        <b>Você não tem permissão para acessar essa área.</b>
      </p>
    </div>
    <div class="ui-g-2">
      <button pButton type="button" class="ui-button-white" label="Voltar" (click)="location.back()"></button>
    </div>
  </div>`
})
export class Erro403Component {
  constructor(public location: Location) { };
}




// WEBPACK FOOTER //
// ./src/app/erros/403.component.ts